/**
 * Form IDs that skip the auth modal and POST directly to /connectors/instance.
 * Auth params are derived from the schema defaults + user context.
 */
export const AUTO_SUBMIT_AUTH_FORM_IDS: string[] = ['brainlead-auth-form'];

/**
 * Form IDs that are automatically filled with audience data (audience_name, createdOn)
 * without showing the form to the user.
 */
export const AUTO_FILL_AUDIENCE_PARAMS_FORM_IDS: string[] = ['brainlead-audience-params'];
